import { load } from 'exifreader'

export const getExifData = async (file: File): Promise<ExifReader.Tags> => {
    // Renaming the file because ExifReader gives and error on weird names
    const newBlob = new Blob([file], { type: file.type })
    const newFile = new File([newBlob], 'normalname', {
        type: file.type,
    })
    const exif = await load(newFile)

    return exif
}

export const canReadFileContent = (file: File | Blob): Promise<boolean> =>
    new Promise((resolve) => {
        const f = new FileReader()
        f.onload = () => resolve(true)
        f.onerror = () => resolve(false)
        f.readAsBinaryString(file.slice(0, 64))
    })
